<mat-card>
    <mat-card-content>
        <ngx-datatable 
                #table
                [loadingIndicator]="loadingIndicator"
                class='material striped' 
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'
                [limit]="params.per_page"
                (sort)="onSort($event)"> 

                <ngx-datatable-column name="Nome" prop="nome" [sortable]="true" [width]="200">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{row.clientes.numero_xp}} - {{row.clientes.nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template >
                        {{row.sigla_ativo}}
                    </ng-template>
                </ngx-datatable-column>
               
                <ngx-datatable-column name="Operação" prop="operacao" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-operacao="value" ngx-datatable-cell-template>
                        {{operacao}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Qtd" prop="qtd" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                        {{qtd}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Preço" prop="preco" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-preco="value" ngx-datatable-cell-template>
                        R$ {{preco | number : '1.2-2'}}
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>     
    </mat-card-content>
</mat-card>